import React from "react"

import {FieldViewProps} from "../../../render/view"
import {ColorPalette} from "../../../color-coding/color-coding"

const debug = false
// const debug = "FieldIconWithColor_View"

export default function FieldIconWithColor_View(props: FieldViewProps) {

    debug && console.log(debug, 'render', props)

    const {icon, color} = props.model[props.field.fieldId]

    const size      = _.get(props.options, 'size', '16')
    const colorize  = _.get(props.options, 'colorize', false)

    const classes = Classes(icon, props.className, {
        'ui5-ico-16': size === '16',
        'ui5-ico-15': size === '15',
        'ui5-ico-13': size === '13'
    })

    const iconStyle: any = {}

    if (colorize) {
        iconStyle.color = gd.skin.colors.mainColor({
            colorNumber: color,
            corePalette: ColorPalette.CORE
        })
    }

    debug && console.log(debug, 'render iconStyle', colorize, color, iconStyle)

    return <div className   = {classes}
                style       = {iconStyle}/>
}
